import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";

import FichaFinanceiraIcon from "@/assets/icons/ficha-financeira.svg?react";
import { Dialog, Dropdown } from "@/ds";
import { FinanceiroStatusTag } from "../../../components/financeiro-status-tag";
import { FinanceiroFichasDialog } from "../financeiro-fichas-dialog";
import { PlanejamentoControle } from "./planejamento-controle";
import {
  ABA_EM_BREVE_TITLE,
  OBRA_DETAIL_SECAO_LABEL,
  OBRA_DETAIL_SECAO_PREFIX,
  GERAR_FICHA_OBRA_LABEL,
  OBRA_DETAIL_ABAS,
  OBRA_DETAIL_ABA_ATIVA,
  OBRA_DETAIL_TITLE,
} from "./financeiro-obra-detail-dialog.constants";
import styles from "./financeiro-obra-detail-dialog.module.scss";
import type { FinanceiroObraDetailDialogViewModel } from "./types-financeiro-obra-detail-dialog";

/** Moldura do detalhamento: seta de voltar, obra e status no título, abas e a ação das fichas. */
export function FinanceiroObraDetailDialogView({
  obraId,
  codigo,
  embarcacao,
  statusFinanceiro,
  isMobile,
  acaoSize,
  tituloClassName,
  fichasAberto,
  abrirFichas,
  voltarDasFichas,
  fechar,
}: FinanceiroObraDetailDialogViewModel) {
  const abaAtiva = OBRA_DETAIL_ABAS[OBRA_DETAIL_ABA_ATIVA];

  const secaoSelect = (
    <Dropdown
      className={styles.secaoSelect}
      value={abaAtiva.titulo}
      options={OBRA_DETAIL_ABAS.map((aba) => ({
        label: aba.titulo,
        value: aba.titulo,
        disabled: !aba.ativa,
      }))}
      optionDisabled="disabled"
      valueTemplate={(option) => (
        <span className={styles.secaoValor}>
          <span className={styles.secaoPrefixo}>{OBRA_DETAIL_SECAO_PREFIX}</span>
          {option?.label}
        </span>
      )}
      aria-label={OBRA_DETAIL_SECAO_LABEL}
      data-testid="financeiro-obra-detail-secao"
    />
  );

  const identificacao = (
    <div className={styles.header} data-testid="financeiro-obra-detail-obra">
      <span>{OBRA_DETAIL_TITLE} /</span>
      <div className={styles.obra}>
        <span className={styles.codigo}>{codigo}</span>
        <span>{embarcacao}</span>
        {statusFinanceiro ? (
          <FinanceiroStatusTag
            status={statusFinanceiro}
            className={styles.statusTag}
            testId="financeiro-obra-detail-status"
          />
        ) : null}
      </div>
    </div>
  );

  const header = isMobile ? (
    <div className={styles.headerMobile}>
      {identificacao}
      {secaoSelect}
    </div>
  ) : (
    identificacao
  );

  const acaoFichas = (
    <div className={isMobile ? styles.acoesMobile : styles.acoes}>
      <Button
        type="button"
        severity="secondary"
        size={acaoSize}
        label={GERAR_FICHA_OBRA_LABEL}
        icon={<FichaFinanceiraIcon aria-hidden />}
        onClick={abrirFichas}
        data-testid="gerar-ficha-obra"
      />
    </div>
  );

  return (
    <>
      <Dialog
        visible
        onHide={fechar}
        size="xl"
        className="p-dialog-ficha"
        header={header}
        headerClassName={styles.headerLinha}
        pt={{ headerTitle: { className: tituloClassName } }}
        focusOnShow={false}
        dismissableMask
        data-testid="financeiro-obra-detail"
      >
        {isMobile ? (
          <div className={styles.mobile} data-testid="financeiro-obra-detail-mobile">
            {acaoFichas}
            <PlanejamentoControle obraId={obraId} />
          </div>
        ) : (
          <TabView
            activeIndex={OBRA_DETAIL_ABA_ATIVA}
            className={styles.abas}
            pt={{ navContainer: { className: styles.abasFixas } }}
          >
            {OBRA_DETAIL_ABAS.map((aba) => (
              <TabPanel
                key={aba.titulo}
                header={aba.titulo}
                disabled={!aba.ativa}
                headerTemplate={
                  aba.ativa
                    ? undefined
                    : (options) => (
                        <span className={options.className} title={ABA_EM_BREVE_TITLE}>
                          {options.titleElement}
                        </span>
                      )
                }
              >
                {aba.ativa ? (
                  <>
                    {acaoFichas}
                    <PlanejamentoControle obraId={obraId} />
                  </>
                ) : null}
              </TabPanel>
            ))}
          </TabView>
        )}
      </Dialog>

      {fichasAberto ? <FinanceiroFichasDialog obraId={obraId} onClose={voltarDasFichas} /> : null}
    </>
  );
}
